<template lang='pug'>
  #sidebar-accordion.accordion.accordion-sidebar(:class='{ "sidebar-margin-top": entityType === "search" }' role='tablist' v-if='entityLoaded')
    .card.card-light.category-accordion-mobile
      #skin-concerns-heading.category-header-mobile.collapsed(data-toggle='collapse' data-target='#skin-concerns-collapse' data-parent='#sidebar-accordion' role='tab')
        i.collapse-arrow(v-if='activeFirstLevelCategories.length > 0')
        h4.h4(v-text='viewAllCategoriesText()')

      #skin-concerns-collapse.collapse(aria-labelledby='skin-concerns-heading' role='tabpanel')

        template(v-if='entityType === "categories"')
          router-link.category-list-mobile(v-if='showAvailableSubcategoriesForCategory(activeCategory)' v-for='category in availableChildCategoriesFor(activeCategory)' :key='category.id' :to='entityPath(category.attributes["slug-url"])' data-toggle='collapse' data-target='#skin-concerns-collapse' data-parent='#sidebar-accordion' role='tab')
            span(v-text='category.attributes["label"]')

        template(v-else)
          template(v-if='!filterCategory.attributes')
            router-link.category-list-mobile(v-if='activeFirstLevelCategories.length > 0' v-for='topLevelCategory in activeFirstLevelCategories' :key='topLevelCategory.id' :to='entityPath(topLevelCategory.attributes["slug-url"])')
              span(v-text='topLevelCategory.attributes["label"]')

          template(v-else)
            router-link.category-list-mobile(v-if='showAvailableSubcategoriesForCategory(activeCategory)' v-for='category in availableChildCategoriesFor(activeCategory)' :key='category.id' :to='entityPath(category.attributes["slug-url"])' data-toggle='collapse' data-target='#skin-concerns-collapse' data-parent='#sidebar-accordion' role='tab')
              span(v-text='category.attributes["label"]')

        router-link.category-back-mobile(v-if='showCategoryBack' data-toggle='collapse' data-target='#skin-concerns-collapse' data-parent='#sidebar-accordion' role='tab' :to='entityPath(previousCategorySlug)')
          i.collapse-back(v-html='arrowLeft')
          h4.h4(v-text='`${$t("backTo")} ${mobileParentFilterText}`')
</template>

<i18n>
{
  "lng_en": {
    "allCategories": "All Categories",
    "backTo": "Back to",
    "categories": "Categories",
    "seeAll": "See all"
  },
  "lng_id": {
    "allCategories": "All Kategori",
    "backTo": "Back to",
    "categories": "Kategori",
    "seeAll": "See all"
  },
  "lng_th": {
    "allCategories": "All Categories",
    "backTo": "Back to",
    "categories": "หมวด",
    "seeAll": "See all"
  },
  "lng_zh": {
    "allCategories": "所有分類",
    "backTo": "回到",
    "categories": "分類",
    "seeAll": "查看全部"
  },
  "lng_ko": {
    "allCategories": "모든 카테고리",
    "backTo": "뒤로 가기",
    "categories": "카테고리",
    "seeAll": "모두 보기"
  }
}
</i18n>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded
    }),

    ...mapGetters([
      'entityPath',
      'activeFirstLevelCategories',
      'availableChildCategoriesFor',
      'showAvailableSubcategoriesForCategory',
      'parentCategoryFor',
      'filterCategory',
      'activeCategory'
    ]),

    arrowLeft: () => '', // Not working
    arrowRight: () => '', // Not working
    isMobile: () => vueSupport.isMobile,
    mobileFilterText () {
      if (this.activeCategory.attributes) {
        return this.activeCategory.attributes['label']
      } else if (this.entityLoaded && this.entityType === 'categories') {
        return this.entity.attributes['label']
      } else {
        return this.$t('categories')
      }
    },
    mobileParentFilterText () {
      if (this.activeCategory.attributes) {
        const parent = this.parentCategoryFor(this.activeCategory)

        if (parent.attributes) {
          return parent.attributes['label']
        }
      }

      if (this.entityType === 'categories') {
        return this.entity.attributes['label']
      }
      return this.$t('allCategories')
    },
    showCategoryBack () {
      return this.filterCategory.attributes || (this.activeCategory.attributes && this.activeCategory.attributes['parent-id'])
    },

    previousCategorySlug () {
      const parentCategory = this.parentCategoryFor(this.activeCategory)

      if (parentCategory.attributes) {
        return parentCategory.attributes['slug-url']
      } else {
        return null
      }
    }
  },

  methods: {
    viewAllCategoriesText () {
      if (I18n.siteCountryLs === 'kr') {
        return `${this.mobileFilterText} ${this.$t('seeAll')}`
      } else {
        return `${this.$t('seeAll')} ${this.mobileFilterText}`
      }
    }
  }
}
</script>

<style lang='scss'>
  .collapse-back,
  .slide-arrow {
    display: inline-block;
    height: 16px;

    svg {
      height: 13px;
      margin-right: 15px;
      vertical-align: middle;
    }
  }
</style>

<style lang='scss' scoped>
  .category-accordion-mobile {
    border-width: 2px !important;
  }

  .category-header-mobile {
    padding: 10px 16px;

    .h4 {
      @include font-weight-bold;
      text-transform: uppercase;
    }
  }

  .category-list-mobile {
    display: block;
    border-top: 2px solid rgba(0, 0, 0, 0.125);
    padding: 10px 16px;

    span {
      pointer-events: none;
    }
  }

  .category-back-mobile {
    display: block;
    border-top: 2px solid rgba(0, 0, 0, 0.125);
    padding: 10px 16px;

    .h4 {
      @include font-weight-bold;
      text-transform: uppercase;
      display: inline-block;
      pointer-events: none;
    }
  }

  .accordion-sidebar {
    .card-header .h4 {
      text-transform: uppercase;
    }

    li .active {
      color: $brand-primary;
    }
  }

  .sidebar-margin-top{
    margin-top: 50px;
  }
</style>
